import { render, staticRenderFns } from "./ConfiguracaoTitulo.vue?vue&type=template&id=2eec90ee"
import script from "./ConfiguracaoTitulo.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoTitulo.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoTitulo.vue?vue&type=style&index=0&id=2eec90ee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports